export const DE = {
  "Accept": "Akzeptieren",
  "Access your assessments, reports and certificates in the Client Portal.": "Greifen Sie im Kundenportal auf Ihre Assessments, Berichte und Zertifikate zu.",
  "Account created": "Konto erstellt",
  "Account created:": "Konto erstellt:",
  "Active": "Aktiv",
  "Add Assessment": "Assessment hinzufügen",
  "Additional Notes": "Zusätzliche Anmerkungen",
  "Admin Portal": "Admin-Portal",
  "Administrator": "Administrator",
  "All": "Alle",
  "All ESAIA assessments and ERI results for your organization.": "Alle ESAIA-Assessments und ERI-Ergebnisse Ihrer Organisation.",
  "Already have an account?": "Haben Sie bereits ein Konto?",
  "Annual Recertification": "Jährliche Rezertifizierung",
  "Answer:": "Antwort:",
  "Answers": "Antworten",
  "Archive": "Archiv",
  "Assessment Activities": "Assessment-Aktivitäten",
  "Assessment ID": "Assessment-ID",
  "Assessment Progress": "Assessment-Fortschritt",
  "Assessment Summary": "Assessment-Zusammenfassung",
  "Assessment Summary (publish per field to the client portal)": "Assessment-Zusammenfassung (pro Feld im Kundenportal veröffentlichen)",
  "Assessment created.": "Assessment erstellt.",
  "Assessment type": "Assessment-Typ",
  "Assessments": "Assessments",
  "Attention required": "Handlungsbedarf",
  "Automatic": "Automatisch",
  "Back to": "Zurück zu",
  "Back to Assessments": "Zurück zu Assessments",
  "Back to Clients": "Zurück zu Kunden",
  "Back to ERI Submissions": "Zurück zu ERI-Einreichungen",
  "Back to website": "Zurück zur Website",
  "Certificate Number": "Zertifikatsnummer",
  "Certificate deleted.": "Zertifikat gelöscht.",
  "Certificate updated.": "Zertifikat aktualisiert.",
  "Certificate uploaded.": "Zertifikat hochgeladen.",
  "Certificate:": "Zertifikat:",
  "Certificates": "Zertifikate",
  "Certification type": "Zertifizierungsart",
  "Change Password": "Passwort ändern",
  "Client": "Kunde",
  "Client Information": "Kundeninformationen",
  "Client Link": "Kundenverknüpfung",
  "Client Portal": "Kundenportal",
  "Client information updated.": "Kundeninformationen aktualisiert.",
  "Client linked": "Kunde verknüpft",
  "Clients": "Kunden",
  "Communications received through ESAIA for info@esaia.org.": "Über ESAIA für info@esaia.org eingegangene Mitteilungen.",
  "Company": "Unternehmen",
  "Completed": "Abgeschlossen",
  "Completion Date": "Abschlussdatum",
  "Confirm new password": "Neues Passwort bestätigen",
  "Confirm password": "Passwort bestätigen",
  "Contact Information": "Kontaktinformationen",
  "Context, number of entities, timelines...": "Kontext, Anzahl der Einheiten, Zeitpläne...",
  "Cookie Policy": "Cookie-Richtlinie",
  "Country": "Land",
  "Create Account": "Konto erstellen",
  "Create Assessment": "Assessment erstellen",
  "Create a new assessment for": "Neues Assessment erstellen für",
  "Create your ESAIA Account": "Erstellen Sie Ihr ESAIA-Konto",
  "Creating account...": "Konto wird erstellt...",
  "Current password": "Aktuelles Passwort",
  "Date": "Datum",
  "Date completed": "Abschlussdatum",
  "Decline": "Ablehnen",
  "Declined": "Abgelehnt",
  "Detailed answers are available for submissions completed after the portal launch.": "Detaillierte Antworten sind für Einreichungen verfügbar, die nach dem Portal-Start abgeschlossen wurden.",
  "Developing": "In Entwicklung",
  "Download": "Herunterladen",
  "Download PDF": "PDF herunterladen",
  "ERI History": "ERI-Verlauf",
  "ERI Result": "ERI-Ergebnis",
  "ERI Results": "ERI-Ergebnisse",
  "ERI Submissions": "ERI-Einreichungen",
  "ESAIA Portal": "ESAIA-Portal",
  "ESAIA Terms": "ESAIA-Bedingungen",
  "ESAIA uses only strictly necessary cookies to keep this website secure and your session active. We do not use advertising or tracking cookies. Read our": "ESAIA verwendet nur unbedingt erforderliche Cookies, um diese Website sicher und Ihre Sitzung aktiv zu halten. Wir verwenden keine Werbe- oder Tracking-Cookies. Lesen Sie unsere",
  "Email": "E-Mail",
  "Enter your email address and we'll send you a secure link to reset your password.": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen sicheren Link zum Zurücksetzen Ihres Passworts.",
  "Established": "Etabliert",
  "Every completed Ethical Readiness Index, newest first.": "Jeder abgeschlossene Ethical Readiness Index, neueste zuerst.",
  "Every registered client organization.": "Jede registrierte Kundenorganisation.",
  "Expired": "Abgelaufen",
  "Expiry date": "Ablaufdatum",
  "First name": "Vorname",
  "For security reasons, you must create a new password before continuing.": "Aus Sicherheitsgründen müssen Sie ein neues Passwort erstellen, bevor Sie fortfahren.",
  "Force ACTIVE": "AKTIV erzwingen",
  "Force EXPIRED": "ABGELAUFEN erzwingen",
  "Forgot Password?": "Passwort vergessen?",
  "Forgot your password?": "Passwort vergessen?",
  "From:": "Von:",
  "Help": "Hilfe",
  "I agree to the": "Ich stimme den",
  "If an account exists for this email address, you will receive a password reset link.": "Falls ein Konto für diese E-Mail-Adresse existiert, erhalten Sie einen Link zum Zurücksetzen des Passworts.",
  "Inbox": "Posteingang",
  "Internal notes": "Interne Notizen",
  "Internal notes (never shown to the client)": "Interne Notizen (werden dem Kunden nie angezeigt)",
  "Job title": "Position",
  "Key Attention Areas": "Wichtige Aufmerksamkeitsbereiche",
  "Key Findings": "Wichtigste Feststellungen",
  "Last Updated": "Zuletzt aktualisiert",
  "Last name": "Nachname",
  "Latest Updates": "Letzte Aktualisierungen",
  "Latest activity": "Letzte Aktivität",
  "Link to Client": "Mit Kunde verknüpfen",
  "Link to client...": "Mit Kunde verknüpfen...",
  "Linked": "Verknüpft",
  "Linked to": "Verknüpft mit",
  "Loading...": "Wird geladen...",
  "Log In": "Anmelden",
  "Log Out": "Abmelden",
  "Log in": "Anmelden",
  "Log out": "Abmelden",
  "Login": "Anmeldung",
  "Mail": "Post",
  "Management Reports": "Management-Berichte",
  "Management Summary": "Management-Zusammenfassung",
  "Management report uploaded.": "Management-Bericht hochgeladen.",
  "Mark as Read": "Als gelesen markieren",
  "Mark as Unread": "Als ungelesen markieren",
  "Minimum 8 characters, with a letter and a number.": "Mindestens 8 Zeichen, mit einem Buchstaben und einer Zahl.",
  "My Account": "Mein Konto",
  "My Assessments": "Meine Assessments",
  "My Certificates": "Meine Zertifikate",
  "My Service Requests": "Meine Serviceanfragen",
  "Name": "Name",
  "New password": "Neues Passwort",
  "Next": "Weiter",
  "No ERI submissions linked to this client.": "Keine ERI-Einreichungen mit diesem Kunden verknüpft.",
  "No ERI submissions yet.": "Noch keine ERI-Einreichungen.",
  "No assessments yet.": "Noch keine Assessments.",
  "No certificates have been uploaded yet.": "Es wurden noch keine Zertifikate hochgeladen.",
  "No clients registered yet.": "Noch keine Kunden registriert.",
  "No emails linked to this client.": "Keine E-Mails mit diesem Kunden verknüpft.",
  "No emails yet.": "Noch keine E-Mails.",
  "No management reports have been uploaded for this assessment.": "Für dieses Assessment wurden noch keine Management-Berichte hochgeladen.",
  "No service requests yet.": "Noch keine Serviceanfragen.",
  "No service requests.": "Keine Serviceanfragen.",
  "No updates yet.": "Noch keine Aktualisierungen.",
  "Not found": "Nicht gefunden",
  "Not linked": "Nicht verknüpft",
  "Not linked to a client account.": "Nicht mit einem Kundenkonto verknüpft.",
  "Page": "Seite",
  "Password": "Passwort",
  "Password successfully updated.": "Passwort erfolgreich aktualisiert.",
  "Phone": "Telefon",
  "Phone number": "Telefonnummer",
  "Please select a certificate PDF.": "Bitte wählen Sie eine Zertifikats-PDF aus.",
  "Previous": "Zurück",
  "Privacy Policy": "Datenschutzerklärung",
  "Profile Information": "Profilinformationen",
  "Question": "Frage",
  "Readiness": "Bereitschaft",
  "Recommendations": "Empfehlungen",
  "Related Emails": "Zugehörige E-Mails",
  "Report deleted.": "Bericht gelöscht.",
  "Request a Service": "Service anfragen",
  "Request an ESAIA Service": "ESAIA-Service anfragen",
  "Request status updated.": "Anfragestatus aktualisiert.",
  "Requested": "Angefragt",
  "Reset Password": "Passwort zurücksetzen",
  "Restore": "Wiederherstellen",
  "Return to Login": "Zurück zur Anmeldung",
  "Risk Summary": "Risikozusammenfassung",
  "Risk indicators": "Risikoindikatoren",
  "Save Changes": "Änderungen speichern",
  "Score": "Punktzahl",
  "Search name, company, email": "Name, Unternehmen, E-Mail suchen",
  "Search sender or subject": "Absender oder Betreff suchen",
  "Security": "Sicherheit",
  "Select a service below. ESAIA will review your request and open an assessment.": "Wählen Sie unten einen Service. ESAIA prüft Ihre Anfrage und eröffnet ein Assessment.",
  "Select an email to read it.": "Wählen Sie eine E-Mail zum Lesen aus.",
  "Select client...": "Kunde auswählen...",
  "Send Reset Link": "Reset-Link senden",
  "Sending...": "Wird gesendet...",
  "Service Requests": "Serviceanfragen",
  "Sign in to your ESAIA portal.": "Melden Sie sich in Ihrem ESAIA-Portal an.",
  "Signing in...": "Anmeldung läuft...",
  "Start Date": "Startdatum",
  "Start date": "Startdatum",
  "Start:": "Start:",
  "Status": "Status",
  "Status (automatic by expiry date; override only if needed)": "Status (automatisch nach Ablaufdatum; nur bei Bedarf überschreiben)",
  "Submission updated.": "Einreichung aktualisiert.",
  "Target completion": "Geplanter Abschluss",
  "This reset link is missing its token. Please use the link from your email.": "Diesem Reset-Link fehlt das Token. Bitte verwenden Sie den Link aus Ihrer E-Mail.",
  "Transparent. Accountable. Ethical.": "Transparent. Verantwortlich. Ethisch.",
  "Type": "Typ",
  "Under Review": "In Prüfung",
  "Unread": "Ungelesen",
  "Update Link": "Verknüpfung aktualisieren",
  "Updated": "Aktualisiert",
  "Updating...": "Wird aktualisiert...",
  "Upload Certificate": "Zertifikat hochladen",
  "Upload Certificate (PDF)": "Zertifikat hochladen (PDF)",
  "Upload PDF Report": "PDF-Bericht hochladen",
  "Valid": "Gültig",
  "View": "Ansehen",
  "View Certificate": "Zertifikat ansehen",
  "Visible to client": "Für Kunden sichtbar",
  "Welcome,": "Willkommen,",
  "You do not have permission to access this resource.": "Sie haben keine Berechtigung, auf diese Ressource zuzugreifen.",
  "Your ESAIA account has been created.": "Ihr ESAIA-Konto wurde erstellt.",
  "Your account information has been updated.": "Ihre Kontoinformationen wurden aktualisiert.",
  "Your complete ESAIA certification history. Expired certificates remain visible for reference.": "Ihre vollständige ESAIA-Zertifizierungshistorie. Abgelaufene Zertifikate bleiben zur Referenz sichtbar.",
  "Your password has been updated successfully.": "Ihr Passwort wurde erfolgreich aktualisiert.",
  "Your privacy at ESAIA": "Ihre Privatsphäre bei ESAIA",
  "Your service request has been submitted.": "Ihre Serviceanfrage wurde übermittelt.",
};
